import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Calendar, ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const blogPosts = [
  {
    slug: "5-leadership-habits",
    title: "5 Leadership Habits That Transform Teams",
    excerpt: "Discover the daily practices that set exceptional leaders apart and create cultures of excellence.",
    date: "March 15, 2024",
    category: "Leadership",
  },
  {
    slug: "power-of-disc",
    title: "The Power of DISC in Building Stronger Teams",
    excerpt: "Learn how understanding personality styles can revolutionize communication and collaboration in your organization.",
    date: "March 8, 2024",
    category: "Team Development",
  },
  {
    slug: "manager-to-leader",
    title: "From Manager to Leader: Making the Shift",
    excerpt: "Explore the critical mindset changes required to transition from managing tasks to leading people.",
    date: "March 1, 2024",
    category: "Career Growth",
  },
  {
    slug: "building-confidence-new-leader",
    title: "Building Confidence as a New Leader",
    excerpt: "Practical strategies to overcome imposter syndrome and step into your leadership potential with clarity.",
    date: "February 24, 2024",
    category: "Personal Development",
  },
];

const Blog = () => {
  return (
    <section className="py-20 bg-muted/30">
      <div className="container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-5xl font-bold text-heading mb-4">
            Leadership Insights & Resources
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Expert guidance, practical tips, and inspiration to help you grow as a leader
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-6xl mx-auto">
          {blogPosts.map((post, index) => (
            <Link key={index} to={`/blog/${post.slug}`}>
              <Card 
                className="hover:shadow-card-hover transition-all duration-300 border-border/50 group cursor-pointer h-full"
              >
                <CardHeader>
                  <div className="flex items-center gap-2 text-sm text-muted-foreground mb-2">
                    <Calendar className="w-4 h-4" />
                    <span>{post.date}</span>
                    <span className="text-accent">• {post.category}</span>
                  </div>
                  <CardTitle className="text-xl group-hover:text-primary transition-colors">
                    {post.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="mb-4">{post.excerpt}</CardDescription>
                  <div className="flex items-center gap-2 text-primary font-medium text-sm">
                    <span>Read More</span>
                    <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
                  </div>
                </CardContent>
              </Card>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link to="/blog">
            <Button variant="outline" size="lg">
              View All Articles
            </Button>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Blog;
